import { render, staticRenderFns } from "./NeskladjaIP.vue?vue&type=template&id=34f47897&scoped=true&"
import script from "./NeskladjaIP.vue?vue&type=script&lang=js&"
export * from "./NeskladjaIP.vue?vue&type=script&lang=js&"
import style0 from "./NeskladjaIP.vue?vue&type=style&index=0&id=34f47897&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f47897",
  null
  
)

export default component.exports